<template>
  <section class="rating">
    <img :src="image" alt="rating" :loading="loading">
    <p>{{$t('qic_landing_rating_desc')}}</p>
  </section>
</template>

<script>
export default {
  name: 'LandingRating',
  props: {
    image: { type: String },
    loading: {
      type: String,
      default: 'eager'
    }
  }
}
</script>
